import { api } from '../utils/request'

export const cabBooking = async (data) => {
    const resp = await api({
        endpoint: '/cabBooking',
        method: 'POST',
        data,
    })
    return resp
}